export const blockRulesSortMapping = {
  createdAt: 'createdAt' as const,
  id: 'id' as const,
  updatedAt: 'updatedAt' as const,
};
